import React, { Component } from "react";
import { Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import configData from "../config.json";
import "./Abha.css";
import ReCAPTCHA from 'react-google-recaptcha';

export default class MobileAuthentication extends Component {
    constructor(props) {
        super(props);
           this.recaptchaRef = React.createRef();
          this.state = {
          textexpanded: false,
          mobile:"",
          // for the 3 parts
         
          captchaToken: null,
        };
      }
      handleCaptchaChange = (value) => {
        this.setState({
          captchaToken: value,
        });
      };
     showToast = (msg, type) => {
         switch (type) {
           case "success":
             toast.success(msg);
             break;
           case "error":
             toast.error(msg);
             break;
            case "warning":
           toast.warning(msg); // 'warn' is used instead of 'warning'
             break;
          default:toast.success(msg);
         }
       };
      toggleReadMore = () => {
        this.setState((prevState) => ({ textexpanded: !prevState.textexpanded }));
      };
      handleaadhaarchange = (e) => {
        e.preventDefault();
        const fieldValue = e.target.value;
        this.setState({ aadharNumber: fieldValue });
      };
    
      // HandleSubmit = (e) => {
      //   e.preventDefault();
      //   const {
      //     captchaToken,
      //     mobile,
      //   } = this.state;
      //   if (mobile.trim() === "") {
      //     this.showToast("Mobile number is required.", "error");
      //     return;
      //   }
      //    const mobileRegex = /^[6-9]\d{9}$/;
      //    if (!mobileRegex.test(mobile.trim())) {
      //     this.showToast("Enter a valid 10-digit mobile number.", "error");
      //     return;
      //   }
        
      //   if (!captchaToken) {
      //      this.showToast('Please verify that you are not a robot!');
      //     return;
      //   }
      //   this.setState({ isSubmitting: true });
      //   var formData = new FormData();
      //   formData.append("mobile", mobile);
      //   formData.append("captchaToken", captchaToken);

      //   fetch(configData.api_url + "C_Abhasearch/mobileSearchVerify", {
      //     method: "POST", 
      //     mode: "cors",
      //     body: formData,
      //   })
      //     .then((response) => response.json())
      //     .then((data) => {
      //       this.showToast(data.message, data.status);
      //       if (data.status === "success") {
      //         sessionStorage.setItem("requestId", data.requestId);
      //         sessionStorage.setItem("mobile", this.state.mobile);

      //         sessionStorage.setItem("message", data.details.message);
      //         window.location.href = "/Mobilenumberotp"; 

      //         // this.mobileSearchVerify();
      //       }else{
      //         window.location.href="/consentcollectionaadhaar";
      //       }
      //       // this.setState({
               
      //       //   isSubmitting: false,
      //       // }); 
      //     });
      // };
      
      // HandleSubmit = (e) => {
      //   e.preventDefault();
      //   const { captchaToken, mobile } = this.state;
      
      //   // Mobile number empty check
      //   if (mobile.trim() === "") {
      //     this.showToast("Mobile number is required.", "error");
      //     return;
      //   }
      
      //   // Mobile number format validation
      //   const mobileRegex = /^[6-9]\d{9}$/;
      //   if (!mobileRegex.test(mobile.trim())) {
      //     this.showToast("Enter a valid 10-digit mobile number.", "error");
      //     return;
      //   }
      
      //   // Captcha validation
      //   if (!captchaToken) {
      //      this.showToast('Please verify that you are not a robot!');
      //     return;
      //   }
      
      //   this.setState({ isSubmitting: true });
      
      //   // Prepare request
      //   var formData = new FormData();
      //   formData.append("mobile", mobile);
      //   formData.append("captchaToken", captchaToken);
       
      //   fetch(configData.api_url + "C_Abhasearch/mobileSearch", {
      //   // fetch(configData.api_url + "C_Abhasearch/mobileSearchVerify", {
      //     method: "POST",
      //     mode: "cors",
      //     body: formData,
      //   })
      //     .then((response) => response.json())
      //     .then((data) => {
      //       this.showToast(data.message, data.status);
      
      //       if (data.status === "success") {
      //         // Save session storage values
      //         sessionStorage.setItem("requestId", data.requestId);
      //         sessionStorage.setItem("mobile", this.state.mobile);
      //         sessionStorage.setItem("message", data.details.message);
      
      //         // Redirect immediately
      //         // window.location.href = "/Mobilenumberotp";
      //       } else {
      //         // Show message and redirect after 5 sec
      //         this.showToast(
      //           "There is no user has found this mobile number. Please create ABHA",
      //           "error"
      //         );
      
      //         setTimeout(() => {
      //           window.location.href = "/consentcollectionaadhaar";
      //         }, 5000);
      //       }
      //     })
         
      //     .finally(() => {
      //       this.setState({ isSubmitting: false });
      //     });
      // };
   
      HandleSubmit = (e) => {
        e.preventDefault();
        const { captchaToken, mobile } = this.state;
      
        // validations...
        const mobileRegex = /^[6-9]\d{9}$/;
        if (mobile.trim() === "") {
          this.showToast("Mobile number is required.", "error");
          return;
        }
        if (!mobileRegex.test(mobile.trim())) {
          this.showToast("Enter a valid 10-digit mobile number.", "error");
          return;
        }
        if (!captchaToken) {
          this.showToast("Please verify that you are not a robot!","error");
          return;
        }
      
        this.setState({ isSubmitting: true });
      
        var formData = new FormData();
        formData.append("mobile", mobile);
        formData.append("captchaToken", captchaToken);
      
        fetch(configData.api_url + "C_Abhasearch/mobileSearch", {
          method: "POST",
          mode: "cors",
          body: formData,
        })
          .then((response) => response.json())
          .then((data) => {
            this.showToast(data.message, data.status);
      
            if (data.status === "success") {
              sessionStorage.setItem("requestId", data.requestId);
              sessionStorage.setItem("mobile", this.state.mobile);
              sessionStorage.setItem("message", data.details.message);
      
              // ✅ Save ABHA list into state
              this.setState({ abhaList: data.details.ABHA || [] });
            } else {
              const allowedErrors = ['Something went wrong','Rate limit exceeded','Unauthorized origin'];
              if (!allowedErrors.includes(data.message))
              {
                  this.showToast("The mobile number you have entered does not match with any of the records. Please enter a different number",
                "error");
      
                  setTimeout(() => {
                    window.location.href = "/consentcollectionaadhaar";
                  }, 7000);
              }
            }
          })
          .finally(() => {
            this.setState({ isSubmitting: false });
          });
      };
      verifySelectedAbha = (abha) => {
        const { mobile, captchaToken } = this.state;
        const requestId = sessionStorage.getItem("requestId");
      
        const formData = new FormData();
        formData.append("mobile", mobile);
        formData.append("captchaToken", captchaToken);
        formData.append("requestId", requestId);
        formData.append("index", abha.index); // ✅ send selected index
      
        fetch(configData.api_url + "C_Abhasearch/mobileSearchVerify", {
          method: "POST",
          mode: "cors",
          body: formData,
        })
          .then((response) => response.json())
          .then((data) => {
            this.showToast(data.message, data.status);
      
            if (data.status === "success") {
              // Save selected ABHA
              sessionStorage.setItem("selectedAbha", JSON.stringify(abha));
      
              // Redirect to OTP page
              window.location.href = "/Mobilenumberotp";
            }  else {
              // Show message and redirect after 5 sec
              this.showToast(
                "There is no user has found this mobile number. Please create ABHA",
                "error"
              );
      
              setTimeout(() => {
                window.location.href = "/consentcollectionaadhaar";
              }, 5000);
            }
          })
         
      };
      
      mobileSearchVerify = () => {
        const {mobile,captchaToken} = this.state;
        const formData = new FormData();
        formData.append("mobile", mobile);
        formData.append("captchaToken", captchaToken);
       // formData.append("requestId", sessionStorage.requestId);
        fetch(configData.api_url + "C_Abhadetails/mobileSearchVerify", {
          method: "POST",
          mode: "cors",
          body: formData,
        })
          .then((response) => response.json())
          .then((data) => {
            
    
            this.showToast(data.message);
    
            if (data.status === "success") {
               window.location.href = "/Mobilenumberotp"; 
                       }
          });
      };  
        onKeyDown = (e) => {
        if (e.key === " ") {
          e.preventDefault();
          toast.error("Spaces are not allowed.");
        }
      };
      handlemobileChange =(e)=>{
        const input = e.target.value;

        // Allow only digits (remove any non-digit character)
        const digitsOnly = input.replace(/\D/g, "");
      
        // Optionally restrict to 10 digits ma
        if (digitsOnly.length <= 10) {
          this.setState({ mobile: digitsOnly });
        }
      }
     
    
      handleAuthChange = (e) => {
        e.preventDefault();
        const fieldValue = e.target.value;
        this.setState({ authenticationtype: fieldValue });
      };
      HandleBackSubmit=()=>{
        window.location="./abharegister"
      }
      resetCaptcha = () => {
        this.setState({ captchaToken: "" });
        if (this.recaptchaRef && this.recaptchaRef.current) {
          this.recaptchaRef.current.reset();
        }
      };
  render() {
    const {mobile} =this.state
    return (
        <div>
        

        <div className="row justify-content-center text-center consentCollectionAadhaar">
          <div className="col-md-6 mt-3">
            <div className="" >
              <Form>
                <Form.Group>
                <Form.Label>
                    <b>Enter 10 Digit Mobile Number</b>
                  </Form.Label>
                  <div className="rounded-0 m-1"
                    style={{
                     gap: "10px"}}
                  >
                   
                    <div className="m-1" 
                    style={{ display: "flex",  }}>
                  <span style={{
                    padding: "4px 12px",
                    background: "#eee",
                    border: "1px solid #ccc",
                    borderRight: "none",
                    borderRadius: "0px"
                  }}>
                  +91
                </span>
                <Form.Control
                  id="mobile"
                  className="form-control rounded-0 "
                  style={{ width:"250px" }}
                  type="text"
                  maxLength={10}
                  value={mobile}
                  onKeyDown={this.onKeyDown}
                  onChange={this.handlemobileChange}
                  placeholder="Enter mobile number"
                />
              </div>
             </div>
                  <br/>
                  
                  <div className="d-flex">    
                    <ReCAPTCHA 
          className="mt-4"
          ref={this.recaptchaRef} 
          sitekey= {configData.captchaKey}
          onChange={this.handleCaptchaChange}
        /> 
        <Button variant="secondary"  className="bi bi-arrow-clockwise re-chaptue" 
                onClick={() => this.recaptchaRef.current.reset()}/>
        </div>
                </Form.Group>
                      
              </Form>
             
            </div>
            
          </div>
          
        </div>
        <div className="row  widget_BG widget_BG_grid m-0 mt-2">
        <div className="col text-start">
        
        <Button className="rounded-0 m-1 " variant="warning"
            onClick={this.HandleBackSubmit}
        
        >
          Back
        </Button>
        </div>
        <div className="col text-end">
        
         
          <Button
            className="rounded-0 m-1"
            disabled={this.state.isSubmitting}
            onClick={this.HandleSubmit}
          >
            {this.state.isSubmitting ? "Submitting..." : "Verifiy Mobile Number"}
          </Button>
        </div>
      </div>
       
      
      <div className="row">
    {this.state.abhaList &&
      this.state.abhaList.map((abha, index) => (
        <div className="col-md-4 mb-3" key={index}>
          <div className="card shadow-sm h-100">
            <div className="card-body">
              <h5 className="card-title">{abha.name}</h5>
              <h6 className="card-subtitle mb-2 text-muted">
                ABHA Number: {abha.ABHANumber}
              </h6>
              <p className="card-text">Gender: {abha.gender}</p>
              <p className="card-text">
                KYC Verified:{" "}
                {abha.kycVerified === "true" ? "✅ Yes" : "❌ No"}
              </p>
              {/* <p>
                <b>Auth Methods:</b>
                <br />
                {abha.authMethods.join(", ")}
              </p> */}
              <Button
                variant="primary"
                onClick={() => this.verifySelectedAbha(abha)}
                // onClick={() => {
                //   sessionStorage.setItem("selectedAbha", JSON.stringify(abha));
                //   window.location.href = "/Mobilenumberotp";
                // }}
              >
                Select ABHA
              </Button>
            </div>
          </div>
        </div>
      ))}
  </div>

      </div>
    )
  }
}
